import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import heroImage from "@/assets/artbaz-hero-house-cropped.png.asset.json";

export function Hero() {
  return (
    <section
      id="domov"
      className="relative flex min-h-screen items-center overflow-hidden bg-background pt-28"
    >
      {/* Green right-angle wedge bleeding to the right & bottom edge of the section */}
      <div
        aria-hidden
        className="pointer-events-none absolute bottom-0 right-0 z-0 h-[72%] w-[62%] bg-gradient-to-br from-primary to-primary-dark md:h-[78%] md:w-[56%]"
        style={{ clipPath: "polygon(100% 0, 100% 100%, 0 100%)" }}
      />
      <div className="container-artbaz relative z-10 w-full">
        <div className="grid items-center gap-10 lg:grid-cols-[2fr_3fr] lg:gap-6">
          {/* Left — copy */}
          <div className="max-w-xl py-10 lg:py-20">
            <span className="eyebrow animate-fade-in">Stavebná firma · Trenčín</span>

            <h1 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl xl:text-7xl">
              Staviame s dôrazom na <span className="text-primary-dark">detail</span>
            </h1>

            <p className="mt-7 max-w-lg text-base leading-relaxed text-muted-foreground sm:text-lg">
              Kompletné rekonštrukcie, stavby a realizácie pod jednou strechou. Precízna práca,
              odborné poradenstvo a výsledky, ktoré vydržia.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Button asChild variant="hero" size="lg">
                <a href="/kontakt">
                  Dohodnúť stretnutie
                  <ArrowRight className="size-5" />
                </a>
              </Button>
              <Button asChild variant="outlineDark" size="lg">
                <a href="/#sluzby">Naše služby</a>
              </Button>
            </div>
          </div>

          {/* Right — transparent house, enlarged, sitting on top of the green wedge */}
          <div className="relative flex items-center justify-center lg:justify-end">
            <img
              src={heroImage.url}
              alt="Moderný rodinný dom s kvalitnou realizáciou od ARTBAZ"
              className="relative z-10 h-auto w-full max-w-[640px] object-contain lg:max-w-[760px]"
              fetchPriority="high"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
